module.exports = __webpack_public_path__ + "static/media/DocumentExpiring.e9794361.svg";